import React, { ChangeEvent } from 'react';
import IOrderFilter, { TOrderFilter } from './IOrderFilter';

import * as elements from '@appStyles/_elements.module.scss';
import * as style from './OrderFilterStyle.module.scss'

const FILTER_OPTIONS = ['Sell', 'Buy', 'Suspended'];

export default class OrderFilter extends React.Component<IOrderFilter, TOrderFilter> {
  state: TOrderFilter = {
    select: '',
  };

  selectChange = (e: ChangeEvent<HTMLSelectElement>) => {
    this.props.filterOrders(e.target.value.toLowerCase());
  }

  render() {
    return (
      <div className={`${elements.select} ${style.select}`}>
        <select
          onChange={this.selectChange}
          title={'Select order type'}
        >
          <React.Fragment>
            <option value="">All</option>
              {FILTER_OPTIONS.map((filter: string) => (
                <option key={filter}>{filter}</option>
            ))}
          </React.Fragment>
        </select>
      </div>
    );
  }
}
